export default function validateItem(item) {
  const isValidMixId =
    !item ||
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.exec(
      item.mixId
    );

  let data = null;

  try {
    if (item) {
      data = JSON.parse(item.data);
    }

    return { isValidMixId, isValidData: true, data, validateDataMessage: null };
  } catch (e) {
    return {
      isValidMixId,
      isValidData: false,
      data,
      validateDataMessage: e.message
    };
  }
}
